import { useDispatch } from "react-redux";

import { USER_UPDATE } from "@store/user/userActions";
import { userUpdate } from "@store/user/userSlice";
import { UserUpdate } from "@types-runway/user";

const useUser = () => {
  const dispatch = useDispatch();

  const updateUser = (updateBody: UserUpdate, isAuth: boolean) => {
    if (isAuth) {
      dispatch({ type: USER_UPDATE, userUpdate: updateBody });
    } else {
      // Update state
      Object.keys(updateBody).forEach((key) => {
        dispatch(
          userUpdate({ name: key as keyof UserUpdate, value: updateBody[key as keyof UserUpdate] })
        );
      });
    }
  };

  return { updateUser };
};

export default useUser;
